export default {
    template: require('../views/loanDetails.html'),
    bindings: {
        loan: '<',
        vertical: '<',
    },
};
